module.exports = __webpack_public_path__ + "static/media/Peras en conserva.e80788a6.webp";